export enum NotificationGroupType {
    STATUS = 'status',
    COMMODITY = 'commodity',
}
